import { useMemo } from 'react'

import { useMemoizedFn } from 'ahooks'

import { KindDetail } from '@eastcoal/api/system/interface'
import { queryKindRootNodesApi } from '@eastcoal/api/system/kind/queryKindRootNodes'

import { RemoteCheckboxGroup } from '@eastcoal/common/components/RemoteCheckboxGroup'
import { isEmpty } from '@eastcoal/common/utils/object'

import { KindRootCheckboxGroupProps } from './interface'

export const KindRootCheckboxGroup = ({
  valueKey = 'id',
  value,
  onChange
}: KindRootCheckboxGroupProps) => {
  const checkboxValue = useMemo(
    () => value?.map(item => `${item[valueKey]}`),
    [value, valueKey]
  )

  const resolveOptions = useMemoizedFn((data: KindDetail[]) =>
    data.map(item => ({
      label: item.name,
      value: item[valueKey]
    }))
  )

  const handleCheckboxChange = (
    value: string[] | undefined,
    data: KindDetail[]
  ) => {
    const newValue = isEmpty(value)
      ? value
      : data.filter(item => value.includes(`${item[valueKey]}`))
    onChange?.(newValue)
  }

  return (
    <RemoteCheckboxGroup
      multiple
      api={queryKindRootNodesApi}
      resolveOptions={resolveOptions}
      value={checkboxValue}
      onChange={handleCheckboxChange}
    />
  )
}
